/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserLastActivityResource { 
    createdAt: string | null;
    platform: string | null;
    platformVersion: string | null;
    appVersion: string | null;
}

